import { useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import I18njs from 'i18n-js';

import Button from 'carbon-react/lib/components/button';
import Form from 'carbon-react/lib/components/form';
import Message from 'carbon-react/lib/components/message';
import Textbox from 'carbon-react/lib/components/textbox';

import Translate from '../../components/Translate/Translate';

const RegisterForm = ({ data, history, inviteToken, onSubmit, user }) => {
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== passwordConfirm) {
      setPasswordsMatch(false);
      return;
    }
    setPasswordsMatch(true);
    const user = {
      inviteToken,
      password,
      passwordConfirm,
      timezone: moment.tz.guess(),
    };

    onSubmit(user);
  };

  const togglePassword = (v) => {
    if (v === 'confirm') {
      setShowPasswordConfirm(!showPasswordConfirm);
    } else {
      setShowPassword(!showPassword);
    }
  };

  const { error } = user;

  return (
    <div className="form-wrapper">
      <Form
        cancel={false}
        saveButton={
          <Button as="primary" className="signup-button" key="register" type="submit">
            <Translate scope="auth.CreateAccount" />
          </Button>
        }
        onSubmit={handleSubmit}
        showSummary={false}
      >
        <div className="title">
          <Translate scope="auth.CreateAccount" />
        </div>
        <div className="subtitle">
          <Translate scope="auth.WevepulledyourCompanyIDandUserIDfromIntacct" />
        </div>
        <div>
          <Textbox
            disabled
            label={I18njs.t('auth.CompanyID')}
            labelInline={false}
            labelAlign="left"
            name="companyID"
            type="text"
            value={data?.company?.intacctCompanyId}
          />
          <Textbox
            disabled
            label={I18njs.t('auth.UserID')}
            labelInline={false}
            labelAlign="left"
            name="userId"
            value={data?.username || data?.email}
          />
          <Textbox
            label={I18njs.t('auth.Password')}
            labelInline={false}
            labelAlign="left"
            name="password"
            onChange={(e) => setPassword(e.target.value)}
            type={showPassword ? 'text' : 'password'}
            value={password}
          >
            <Button buttonType="tertiary" onClick={togglePassword} size="small">
              {showPassword ? <Translate scope="auth.HIDE" /> : <Translate scope="auth.SHOW" />}
            </Button>
          </Textbox>
          <Textbox
            label={I18njs.t('auth.ConfirmPassword')}
            labelInline={false}
            labelAlign="left"
            name="passwordConfirm"
            onChange={(e) => setPasswordConfirm(e.target.value)}
            type={showPasswordConfirm ? 'text' : 'password'}
            value={passwordConfirm}
          >
            <Button buttonType="tertiary" size="small" onClick={() => togglePassword('confirm')}>
              {showPasswordConfirm ? <Translate scope="auth.HIDE" /> : <Translate scope="auth.SHOW" />}
            </Button>
          </Textbox>
        </div>
        {!passwordsMatch && (
          <div style={{ margin: '10px 0' }}>
            <Message variant="error">
              <Translate scope="auth.PasswordsDontMatch" />
            </Message>
          </div>
        )}
        {error && error.message && (
          <div className="error-wrapper">
            <Message variant="error">{error.message}</Message>
          </div>
        )}
      </Form>
      <div className="footer-content">
        <div className="already-text">
          <Translate scope="auth.Alreadyhaveaccount" />
        </div>
        <Button buttonType="tertiary" className="login-button" onClick={() => history.push('/login')} size="small">
          <Translate scope="auth.LogIn" />
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterForm));
